import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth";
import { Logo, LogoLight } from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const isSucc = (params.get("context") || "").toLowerCase() === "succession";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) {
      // Redirection intelligente : "next" prime, sinon choix-espace si vide, sinon carnet/succession
      const next = params.get("next");
      if (next) {
        nav(next);
      } else if (!res.user?.chosen_space) {
        nav("/choix-espace");
      } else {
        nav(res.user.chosen_space === "succession" ? "/succession" : "/carnet");
      }
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12" style={{ backgroundColor: isSucc ? "#123B36" : "var(--auprea-cream)" }} data-testid={isSucc ? "login-succession-context" : "login-default"}>
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-8 text-center">
          {isSucc ? <LogoLight size={36} /> : <Logo size={36} />}
        </Link>
        {isSucc && (
          <div style={{ background: "rgba(173,124,51,0.15)", border: "1px solid rgba(173,124,51,0.35)", color: "#F6F2E9", padding: "12px 16px", borderRadius: 6, marginBottom: 18, fontSize: 13.5, lineHeight: 1.55 }} data-testid="login-succession-banner">
            <strong style={{ color: "#E1BA6C" }}>Votre diagnostic succession vous attend.</strong>{" "}
            Connectez-vous pour reprendre votre parcours là où vous l'avez laissé.
          </div>
        )}
        <div className="auprea-card" style={isSucc ? { background: "#FFFDF7", borderColor: "rgba(173,124,51,0.25)" } : undefined}>
          <h1 style={{ fontSize: 28, marginBottom: 6, color: isSucc ? "#123B36" : undefined }}>Connexion</h1>
          <p style={{ color: "rgba(35,38,46,0.7)", marginBottom: 28, fontSize: 15 }}>
            {isSucc ? "Retrouvez votre dossier succession en cours." : "Accédez à votre espace client AUPREA."}
          </p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="auprea-label">Email</label>
              <input
                type="email"
                className="auprea-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="auprea-label">Mot de passe</label>
              <input
                type="password"
                className="auprea-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            {error && error === "ADMIN_LOGIN_REQUIRED" ? (
              <div style={{ color: "#15294f", fontSize: 14, padding: "14px 16px", backgroundColor: "rgba(202,168,106,0.12)", border: "1px solid rgba(202,168,106,0.4)", borderRadius: 4, lineHeight: 1.55 }} data-testid="login-error">
                <strong>Compte administrateur détecté.</strong><br/>
                Ce compte doit se connecter via l'espace direction :{" "}
                <Link to="/direction/connexion" style={{ color: "var(--auprea-blue)", textDecoration: "underline", fontWeight: 600 }} data-testid="link-admin-login">
                  Accéder à /direction/connexion
                </Link>
              </div>
            ) : error && error === "PARTNER_LOGIN_REQUIRED" ? (
              <div style={{ color: "#15294f", fontSize: 14, padding: "14px 16px", backgroundColor: "rgba(202,168,106,0.12)", border: "1px solid rgba(202,168,106,0.4)", borderRadius: 4, lineHeight: 1.55 }} data-testid="login-error">
                <strong>Compte partenaire détecté.</strong><br/>
                Connectez-vous via votre espace partenaire dédié, ou{" "}
                <Link to="/contact" style={{ color: "var(--auprea-blue)", textDecoration: "underline" }}>contactez-nous</Link>.
              </div>
            ) : error && (
              <div style={{ color: "#b53a3a", fontSize: 14, padding: "10px 12px", backgroundColor: "#fcf3f3", border: "1px solid #f0c5c5" }} data-testid="login-error">
                {error}
              </div>
            )}
            <button type="submit" className="auprea-btn w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
          <div className="mt-4 text-center text-sm">
            <Link
              to="/mot-de-passe-oublie"
              style={{ color: "var(--auprea-blue)" }}
              data-testid="link-forgot-password"
            >
              Mot de passe oublié&nbsp;?
            </Link>
          </div>
          <div className="mt-6 text-center text-sm" style={{ color: "rgba(35,38,46,0.7)" }}>
            Pas encore de compte ?{" "}
            <Link to="/inscription" style={{ color: "var(--auprea-blue)", fontWeight: 500 }} data-testid="link-register">
              Créer votre espace client
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
